// Ubicación: src/components/hooks/useEmpresaSubcategorias.ts
//
// La lectura de las subcategorías ya guardadas viene de
// empresa.subcategorias (incluida en vista_empresa_detalle).
// Este hook solo se encarga de escribir los cambios.
//
// En vez de borrar todo y reinsertar todo (frágil: vuelve a tocar
// filas que no cambiaron), calculamos el diff: solo borramos lo que
// se ha quitado, y hacemos upsert de lo seleccionado actualmente
// (upsert para que nunca falle si la fila ya existía).

import { supabase } from '@/lib/supabaseClient';

export function useEmpresaSubcategorias() {
  const guardarSubcategorias = async (
    idEmpresa: string,
    idsAnteriores: string[],
    nuevosIds: string[]
  ) => {
    const aEliminar = idsAnteriores.filter((id) => !nuevosIds.includes(id));

    if (aEliminar.length > 0) {
      const { error: errorDelete } = await supabase
        .from('empresa_subcategoria')
        .delete()
        .eq('id_empresa', idEmpresa)
        .in('id_subcategoria', aEliminar);

      if (errorDelete) return { error: errorDelete };
    }

    if (nuevosIds.length > 0) {
      const filas = nuevosIds.map((id_subcategoria) => ({
        id_empresa: idEmpresa,
        id_subcategoria,
      }));
      const { error: errorInsert } = await supabase
        .from('empresa_subcategoria')
        .upsert(filas, { onConflict: 'id_empresa,id_subcategoria' });

      if (errorInsert) return { error: errorInsert };
    }

    return { error: null };
  };

  return { guardarSubcategorias };
}